export const readLoadTestSession = (key) => {
    const read = (storage) => {
        try {
            const value = JSON.parse(window[storage].getItem(key));
            return value?.jobId ? value : null;
        } catch { return null; }
    };
    const local = read('localStorage');
    const tab = read('sessionStorage');
    if (local) {
        return !local.finalReportData && tab?.finalReportData && String(tab.jobId) === String(local.jobId)
            ? { ...local, finalReportData: tab.finalReportData } : local;
    }
    if (tab) {
        try {
            window.localStorage.setItem(key, JSON.stringify(tab));
            window.sessionStorage.removeItem(key);
        } catch { /* Keep the tab copy when persistent storage is blocked. */ }
    }
    return tab;
};

export const writeLoadTestSession = (key, jobId, data, compactReport) => {
    let serialized;
    try {
        serialized = JSON.stringify({
            jobId: String(jobId),
            ...(data ? { finalReportData: compactReport(data) } : {}),
        });
    } catch {
        serialized = JSON.stringify({ jobId: String(jobId) });
    }
    try {
        window.localStorage.setItem(key, serialized);
        try { window.sessionStorage.removeItem(key); } catch { /* The persistent copy is saved. */ }
    } catch {
        try { window.localStorage.setItem(key, JSON.stringify({ jobId: String(jobId) })); } catch { /* Use the tab fallback. */ }
        try { window.sessionStorage.setItem(key, serialized); } catch { /* Storage is optional. */ }
    }
};

export const removeLoadTestSession = (key) => {
    for (const storage of ['localStorage', 'sessionStorage']) {
        try { window[storage].removeItem(key); } catch { /* Storage is optional. */ }
    }
};
